import React from 'react';

const SalesHeader = () => {
  return (
    <div className="sales-header">
      <div className="sales-header-content">
        <h1 className="sales-title">Today Sales</h1>
        <p className="sales-subtitle">Track and manage all your sales transactions</p>
      </div>
    </div>
  );
};

export default SalesHeader;